"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _reactJsPagination = _interopRequireDefault(require("react-js-pagination"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = _interopRequireDefault(require("lodash"));
var _select = _interopRequireDefault(require("../select"));
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLASS_NAME = _styles.default.paginationContainer;
var ExternalPagination = /*#__PURE__*/function (_Component, _componentDidUpdate) {
  (0, _inherits2.default)(ExternalPagination, _Component);
  var _super = _createSuper(ExternalPagination);
  function ExternalPagination(props) {
    var _this;
    (0, _classCallCheck2.default)(this, ExternalPagination);
    _this = _super.call(this, props);
    _this.state = {
      activePage: props.serverPagination ? props.serverPage : 1,
      activeRowsRange: props.sizePerPage || 10
    };
    _this.setPageData = _this.setPageData.bind((0, _assertThisInitialized2.default)(_this));
    _this.showTotalRecords = _this.showTotalRecords.bind((0, _assertThisInitialized2.default)(_this));
    _this.checkData = _this.checkData.bind((0, _assertThisInitialized2.default)(_this));
    _this.showRecordsPerPage = _this.showRecordsPerPage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(ExternalPagination, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.checkData()) {
        if (this.props.serverPagination) {
          this.props.returnData(null, this.state.activePage);
        } else {
          this.props.returnData(this.setPageData(), this.state.activePage);
        }
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(_x) {
      return (_componentDidUpdate = _componentDidUpdate || (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(prevProps) {
        var prevData, currData, lengthDiff;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              prevData = prevProps.data || [];
              currData = this.props.data || [];
              lengthDiff = prevData.length - currData.length;
              if (!(!this.props.serverPagination && lengthDiff > 0)) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return this.setBackActivePage();
            case 6:
              if (this.props.serverPagination) {
                this.props.returnData(null, this.state.activePage);
              } else {
                this.props.returnData(this.setPageData(), this.state.activePage);
              }
              _context.next = 10;
              break;
            case 9:
              if (!_lodash.default.isEqual(prevData, currData)) {
                if (this.props.serverPagination) {
                  this.props.returnData(null, this.state.activePage);
                } else {
                  this.props.returnData(this.setPageData(), this.state.activePage);
                }
              }
            case 10:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }))).apply(this, arguments);
    }
  }, {
    key: "setBackActivePage",
    value: function setBackActivePage() {
      if (this.state.activePage !== 1) {
        this.setState({
          activePage: 1
        });
      }
    }
  }, {
    key: "setSizePerPage",
    value: function setSizePerPage(selectedRange) {
      if (this.state.activeRowsRange !== selectedRange.value) {
        this.setState({
          activeRowsRange: selectedRange.value
        });
        this.props.onChangeSizePerPage(selectedRange.value);
      }
    }
  }, {
    key: "setPageData",
    value: function setPageData() {
      var _this$props = this.props,
        data = _this$props.data,
        sizePerPage = _this$props.sizePerPage;
      var activePage = this.state.activePage;
      var startIndex = activePage * sizePerPage - sizePerPage;
      var endIndex = startIndex + sizePerPage;
      var pageData = [];
      pageData = data.slice(startIndex, endIndex);
      return pageData;
    }
  }, {
    key: "showTotalRecords",
    value: function showTotalRecords() {
      var _this$props2 = this.props,
        sizePerPage = _this$props2.sizePerPage,
        showTotalRecordsClass = _this$props2.showTotalRecordsClass,
        serverTotalRecords = _this$props2.serverTotalRecords,
        serverPagination = _this$props2.serverPagination,
        serverPage = _this$props2.serverPage,
        t = _this$props2.t;
      var total = serverPagination ? serverTotalRecords : this.props.data.length;
      var activePage = serverPagination ? serverPage : this.state.activePage;
      var startIndex = total === 0 ? 0 : activePage * sizePerPage - sizePerPage + 1;
      var endIndex = startIndex + sizePerPage <= total ? startIndex + sizePerPage - 1 : total;
      var totalDisplay = total ? total.toLocaleString() : 0;
      return total === 0 ? null : /*#__PURE__*/_react.default.createElement("div", {
        className: showTotalRecordsClass || 'showTotalRecords'
      }, t('Showing'), " ", startIndex, "-", endIndex, " ", t('of'), " ", totalDisplay);
    }
  }, {
    key: "showRecordsPerPage",
    value: function showRecordsPerPage() {
      var _this2 = this;
      var _this$props3 = this.props,
        rowsRange = _this$props3.rowsRange,
        t = _this$props3.t;
      var rowOptions = rowsRange.map(function (range) {
        return {
          label: range,
          value: range
        };
      });
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
        className: "show-rows"
      }, /*#__PURE__*/_react.default.createElement(_select.default, {
        options: rowOptions,
        placeholder: "",
        onChange: function onChange(selectedValue) {
          return _this2.setSizePerPage(selectedValue);
        },
        closeOnSelect: true,
        value: this.state.activeRowsRange
      }), /*#__PURE__*/_react.default.createElement("span", {
        className: "records-text"
      }, t('Rows per page'))));
    }
  }, {
    key: "checkData",
    value: function checkData() {
      var _this$props4 = this.props,
        data = _this$props4.data,
        serverTotalRecords = _this$props4.serverTotalRecords,
        serverPagination = _this$props4.serverPagination;
      if (serverPagination && !serverTotalRecords) {
        return false;
      }
      return data && Array.isArray(data) && data.length > 0;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props5 = this.props,
        paginationContainerClass = _this$props5.paginationContainerClass,
        pageRange = _this$props5.pageRange,
        returnData = _this$props5.returnData,
        serverPagination = _this$props5.serverPagination,
        serverPage = _this$props5.serverPage,
        serverTotalRecords = _this$props5.serverTotalRecords,
        sizePerPage = _this$props5.sizePerPage,
        onChangeCurrentPage = _this$props5.onChangeCurrentPage,
        showRowsPerPage = _this$props5.showRowsPerPage;
      var dataExist = this.checkData();
      return /*#__PURE__*/_react.default.createElement("div", {
        className: paginationContainerClass || CLASS_NAME
      }, dataExist ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, showRowsPerPage ? this.showRecordsPerPage() : this.showTotalRecords()) : null, /*#__PURE__*/_react.default.createElement("div", null, !dataExist ? null : /*#__PURE__*/_react.default.createElement(_reactJsPagination.default, {
        activePage: serverPagination ? serverPage : this.state.activePage,
        itemsCountPerPage: sizePerPage,
        totalItemsCount: serverPagination ? serverTotalRecords : this.props.data.length,
        pageRangeDisplayed: pageRange,
        prevPageText: "\u2039",
        nextPageText: "\u203A",
        onChange: function onChange(pagenum) {
          onChangeCurrentPage(pagenum);
          _this3.setState({
            activePage: pagenum
          }, function () {
            if (serverPagination) {
              returnData(null, pagenum);
            } else {
              var retdata = _this3.setPageData();
              returnData(retdata, pagenum);
            }
          });
        }
      })));
    }
  }]);
  return ExternalPagination;
}(_react.Component);
ExternalPagination.propTypes = {
  paginationContainerClass: _propTypes.default.string,
  showTotalRecordsClass: _propTypes.default.string,
  data: _propTypes.default.instanceOf(Array),
  pageRange: _propTypes.default.number,
  returnData: _propTypes.default.func,
  serverPagination: _propTypes.default.bool,
  serverPage: _propTypes.default.number,
  serverTotalRecords: _propTypes.default.number,
  sizePerPage: _propTypes.default.number,
  onChangeCurrentPage: _propTypes.default.func,
  onChangeSizePerPage: _propTypes.default.func,
  t: _propTypes.default.func,
  rowsRange: _propTypes.default.instanceOf(Array),
  showRowsPerPage: _propTypes.default.bool
};
ExternalPagination.defaultProps = {
  paginationContainerClass: null,
  showTotalRecordsClass: null,
  data: [],
  pageRange: 5,
  returnData: function returnData(retdata) {
    return retdata;
  },
  serverPagination: false,
  serverPage: 1,
  serverTotalRecords: 0,
  sizePerPage: 20,
  onChangeCurrentPage: function onChangeCurrentPage(num) {
    return num;
  },
  onChangeSizePerPage: function onChangeSizePerPage(num) {
    return num;
  },
  t: function t(x) {
    return x;
  },
  rowsRange: [5, 10, 15, 20],
  showRowsPerPage: false
};
var _default = ExternalPagination;
exports.default = _default;